export enum LoaderTranslationKey {
  UploadingPhotos = "vehicle_analysis.uploading_photos",
  ScanningPhotos = "vehicle_analysis.scanning_photos",
  AnalysingDamage = "vehicle_analysis.assessing_damage",
}
